<template>
	<div>
		<v-dialog v-model="dialog_pendingTransactions" no-click-animation persistent scrollable fullscreen content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card flat>

	        	<v-toolbar flat fixed>
			      <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
			      <v-toolbar-title class="white--text">{{type == 'orders' ? 'Order(s)' : type == 'challans' ? 'Delivery Challan(s)' : type == 'invoices' ? 'Sale Invoice(s)' : type == 'estimates' ? 'Estimate(s)' : ''}}</v-toolbar-title>
			      <v-spacer></v-spacer>
			      <v-btn round-borders outline @click="fn_getPendingItems">Done</v-btn>

			      <v-text-field  flat solo placeholder="Search..." v-model="searchValue" slot="extension" ></v-text-field>
			    </v-toolbar>

		        <v-card-text full-height nopadding  style="padding-top:104px !important">

		        	<v-list two-line nopadding>
		        		<div v-for="(item, index) in filteredItems" :key="index">
		        			<v-list-tile list-checkbox @click="fn_changeSelection(item)">

					            <v-list-tile-content>
					              <v-list-tile-title>
					              	<!-- {{item.prefix}}/{{item.transactionNumber}}{{item.suffix ? '/' + item.suffix : ''}} -->
					              	{{item.mergeTransactionNumber}}
					              </v-list-tile-title>
					              <v-list-tile-sub-title>
					              	{{item.transactionDate | moment("DD-MMM-YYYY")}}
					              </v-list-tile-sub-title>
					            </v-list-tile-content>

					            <v-list-tile-action>
						            <v-checkbox v-model="item.selected" @change="fn_changeSelection(item)"></v-checkbox>
						        </v-list-tile-action>

				        	</v-list-tile>

				        	<v-divider v-if="filteredItems.length-1 != index"></v-divider>
		        		</div>

		        	</v-list>
			        	


			        <div class="display_msg" v-if="!filteredItems.length">No Items</div>
		        </v-card-text>
		    </v-card>


	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['items', 'type', 'getPendingItems'],
		data(){
			return{
				ordersList:[],
				dialog_pendingTransactions:false,
				searchValue:'',
				selected:false
			}
		},
		methods:{
			openDialogWeb: function () {
				this.searchValue = '';
				this.dialog_pendingTransactions = true;
			},
			closeDialogWeb: function () {
				this.dialog_pendingTransactions = false;
			},
			fn_getPendingItems: function () {

				if(!this.filteredItems.length){
					this.$parent.fn_closeDialog();
					return;
				}

				let transactionIds = [];
				this.filteredItems.forEach(function (item) {
					item.selected ? transactionIds.push(item.transactionId) : '';
				});
				console.log(transactionIds);

				if(transactionIds.length){
					this.getPendingItems(transactionIds, this.type);
				}
				else{
					// this.$parent.snackbar = true;
					// this.$parent.snackbar_msg = 'Select transaction.';
					this.showToast("Select transaction");
				}
			},
			fn_changeSelection: function (item) {

				let self = this;
				if(this.type=='invoices'){
					this.items.forEach(function(invoiceItem){
						// if(item.transactionNumber != invoiceItem.transactionNumber){
						if(item.mergeTransactionNumber != invoiceItem.mergeTransactionNumber){
							invoiceItem.selected = false;
							self.$forceUpdate();
						}
						else{
							invoiceItem.selected = !invoiceItem.selected;
							self.$forceUpdate();
						}
					})
				}
				else{
					item.selected = !item.selected;
					this.$forceUpdate();
				}
				
			}
		},
		computed:{
			filteredItems: function () {
		        let searchText = this.searchValue.toLowerCase();

		        if(this.items && this.items.length){

		        	return this.items.filter(item => {
			          let keyword = searchText.toLowerCase();

			          // let transactionNumber = item.transactionNumber;
			          // let prefix = item.prefix.toLowerCase();
			          // let suffix = item.suffix ? '/' + item.suffix.toLowerCase() : '';

			          // let wholeNumber = prefix + '/' + item.transactionNumber + suffix;
			          // console.log(wholeNumber);
			          // return wholeNumber.match(keyword) || transactionNumber.toString().match(keyword);
			          let transactionNumberString = item.mergeTransactionNumber.toLowerCase();
			          return transactionNumberString.match(keyword);
			        });
			        
			    }
			    else{
		        	return [];
		        }


		    }
		        
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/sale/dialogs/dialog_pending_transactions.vue